<template>
  <ui-menu
    v-model="menu"
    :has-triangle="true"
    location="bottom end"
    :offset="[0, 25]"
    :items="menuList"
    :menu-props="{
      menuWidth: 188,
    }"
  >
    <template #activator="{ props: activatorProps }">
      <div
        class="report-tabs-actions__activator"
        @click.stop
        @pointerdown.stop
        @mousedown.stop
      >
        <div v-bind="activatorProps">
          <ui-chevron
            :open="menu"
            color="inherit"
          ></ui-chevron>
        </div>
      </div>
    </template>
  </ui-menu>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useColors } from '@/composables';

const props = defineProps<{
  item?: unknown;
  hasBookmark?: boolean;
}>();

const emit = defineEmits<{
  'open-bookmark': [];
}>();

const $colors = useColors();
const menu = ref(false);

const menuList = computed((): Bemob.ListItem[] => {
  const addToBookmark: Bemob.ListItem = {
    key: 'addToBookmark',
    title: 'Add Bookmark',
    iconAppend: props.hasBookmark ? 'fas fa-star' : 'far fa-star',
    iconColor: props.hasBookmark ? $colors.sunglow : null,
    click: () => emit('open-bookmark'),
  };

  return [addToBookmark];
});

</script>

<style lang="scss" scoped>
.report-tabs-actions__activator {
  display: flex;
  align-items: center;
  cursor: pointer;
}
</style>
